import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import { api } from "../lib/api";

function fmt(iso) { if(!iso) return ""; const d=new Date(iso); return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()} ${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`; }

export default function Notifications() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get("/notifications", { params: { limit: 100 } });
    setItems(data);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const openItem = async (n) => {
    if (!n.read_at) await api.post(`/notifications/${n.id}/read`).catch(() => {});
    const p = n.payload || {};
    if (n.kind === "new_message" && p.thread_id) navigate(`/messages/${p.thread_id}`);
    else if (p.mission_id) navigate(`/missions/${p.mission_id}`);
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="notifications-page">
      <Header />
      <main className="mx-auto max-w-3xl px-6 py-10">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">{t("notifications.title_page")}</h1>
          <button onClick={readAll} className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50" data-testid="notif-page-read-all">
            {t("notifications.read_all")}
          </button>
        </div>
        {loading && <p className="text-center text-slate-500">{t("common.loading")}</p>}
        {!loading && items.length === 0 && (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm" data-testid="notifications-empty">
            <p className="text-sm text-slate-600">{t("notifications.empty")}</p>
          </div>
        )}
        <ul className="space-y-2">
          {items.map((n) => (
            <li key={n.id}>
              <button onClick={() => openItem(n)} className={"flex w-full items-start gap-3 rounded-2xl border p-4 text-left shadow-sm " + (n.read_at ? "border-slate-200 bg-white" : "border-indigo-200 bg-indigo-50/60")} data-testid={`notif-page-item-${n.id}`}>
                <span className="text-xl">{n.kind === "new_message" ? "💬" : n.kind === "submission_hired" ? "🎉" : n.kind === "new_submission" ? "📥" : "🔔"}</span>
                <div className="flex-1">
                  <p className="text-sm text-slate-800">{t(`notifications.copy_${n.kind}`, { ...n.payload, defaultValue: n.kind })}</p>
                  <p className="mt-0.5 text-[11px] text-slate-500">{fmt(n.created_at)}</p>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
